import React, { useState } from "react";
import { Button, Input, Tag, Tooltip } from "antd";
import {
    EditOutlined, DeleteOutlined, FolderFilled
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { removeBuildTarget, removeBuildTargetGroup, setConfigSelectedBehavior, setConfigSelectedTarget, setStep, setToEditData, updateBuildTargetItemName } from "../../../store/components/MarketExplorer.slice";
import { filterSelections, getAudienceSizeHover, getMarketExplorerText, getModuleCode, getNextStep, getPackage, getPackageObj, getStepToDisplay, renderTargetSelectionItems } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import MarketExplorerServices from "../../../services/MarketExplorer.services";
import { folderStyle, isArray } from "../../../utils/MainHelper";

function Group({
    data, parent, groupId, clickableAnd
}) {
    const dispatch = useDispatch();
    const { reportIsLoading } = useSelector((state) => state.reports);

    const {
        countryNotAvailable,
        setup: {
            marketPackage
        }
    } = useSelector((state) => state.buildTargets);

    const onEditBody = () => {
        if (reportIsLoading) return;
        dispatch(setConfigSelectedTarget(data));
        dispatch(setConfigSelectedBehavior(data.bahavior));
        dispatch(setToEditData({
            mode: "edit",
            data: {
                ...data,
                audienceId: parent.key,
                groupIndex: groupId
            }
        }));
        dispatch(setStep(2));
    };

    const hideNext = (() => {
        const explorerList = MarketExplorerServices.getMarketExplorerList();
        if (marketPackage) {
            const [item] = filterSelections(explorerList.behavioralAndAttributes, parent.key)
            let isDoneSteps = getStepToDisplay(item, parent.key);
            if (isArray(isDoneSteps) && !isDoneSteps.length) return true
            if (isDoneSteps && isDoneSteps !== true && !isArray(isDoneSteps)) {
                if (isDoneSteps.subSteps) return {
                    step: true,
                    list: isDoneSteps.subSteps
                }
                isDoneSteps = [isDoneSteps]
            }
            if (isArray(isDoneSteps)) isDoneSteps = isDoneSteps.find((item) => item.stepEnd);
            return isDoneSteps;
        }
        return false;
    })();

    const packageCode = getPackage();
    const moduleCode = getModuleCode();

    const getName = (target) => {
        const { mokb, path, namePath, name } = target;
        if ((["aitag"].includes(packageCode) || ["facebookaudiences"].includes(moduleCode)) && namePath) return namePath.replace("/", " - ");
        if (mokb) {
            return (path || namePath).replace("/", " - ");
        }
        return name;
    };

    const getNextComponent = () => {
        if (["whitespaces"].includes(packageCode)) return null
        if (["whitespaces"].includes(packageCode) && hideNext === true) return null
        if (hideNext && hideNext.step && hideNext.list.length) {
            const onClick = (item) => {
                dispatch(setToEditData({
                    mode: "and",
                    data: {
                        ...data,
                        audienceId: parent.key,
                        groupIndex: groupId
                    }
                }));
                dispatch(setConfigSelectedTarget(item));
                dispatch(setStep(2));
            }
            return null
            return <>
                {hideNext.list.map((item) => renderTargetSelectionItems(item, onClick))}
            </>
        }
        return <Button
            disabled={reportIsLoading || countryNotAvailable}
            style={{ minWidth: "10mm" }}
            onClick={() => {
                dispatch(setToEditData({
                    mode: "and",
                    data: {
                        ...data,
                        audienceId: parent.key,
                        groupIndex: groupId
                    }
                }));
                if (["whitespaces"].includes(packageCode)) {
                    const nextStep = getNextStep(data);
                    if (nextStep) {
                        dispatch(setConfigSelectedTarget(nextStep));
                        dispatch(setStep(2));

                        return;
                    }
                }
                dispatch(setStep(1));
            }}
        >
            {["whitespaces"].includes(packageCode) ? "NEXT" : "and"}
        </Button>
    }
    return (
        <div className="group">
            <div className="group-header d-flex align-items-center justify-content-between">
                <div className="group-header-value">{getMarketExplorerText(data)}</div>
                <div className="d-flex align-item-center">
                    <Button
                        style={{ padding: ".5mm" }}
                        type="link"
                        onClick={onEditBody}
                        disabled={reportIsLoading || countryNotAvailable}
                    >
                        Edit
                    </Button>
                </div>
            </div>
            <div className={`group-body${reportIsLoading ? " disabled" : ""}`}>
                {data.targets.map((target, idx) => {
                    const childList = target.children || target.tempChildren;
                    let isFolder = true;
                    if (childList?.length === 1) {
                        if (target.name === childList[0].name) isFolder = false;
                    } else if (!childList) {
                        isFolder = false;
                    }
                    const hasHover = getAudienceSizeHover(target, data);
                    const TagItem = <Tag
                        className="oi-tag"
                        key={target.key || target.name}
                        icon={(
                            <>
                                {isFolder
                                    ? <FolderFilled style={{ ...folderStyle, marginRight: 0 }} /> : ""}
                            </>
                        )}
                        onHove
                    >
                        {getName(target)}
                    </Tag>

                    return (
                        <div key={target.key || target.name} className="d-flex flex-wrap align-items-center" style={{ gap: "1mm" }}>
                            {hasHover
                                ? <Tooltip title={hasHover}>{TagItem}</Tooltip>
                                : TagItem}
                            {(data.targets.length - 1) !== idx && packageCode !== "whitespaces" && <span className="and">and</span>}
                        </div>
                    );
                })}
                {data.code !== "target_focus" && (data.isStep ? clickableAnd : true) && (
                    <Button
                        style={{ display: "none" }}
                        danger
                        className="group-body-delete"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (["healthcarewhitespaces", "veterinaryjourney"].includes(moduleCode) && !groupId) {
                                dispatch(removeBuildTarget(parent));
                            } else {
                                dispatch(removeBuildTargetGroup({
                                    audienceId: parent.key,
                                    groupIndex: groupId
                                }));
                            }
                        }}
                        icon={<DeleteOutlined style={{ fontSize: "15px" }} />}
                        type="link"
                        disabled={reportIsLoading || countryNotAvailable}
                    />
                )}
            </div>
            <div className="group-footer">
                {clickableAnd ? (
                    <>  {getNextComponent()} </>
                ) : packageCode !== "whitespaces" && <span>and</span>}

            </div>
        </div>
    );
}
const TargetItemGroup = function ({ data }) {
    const dispatch = useDispatch();
    const [editMode, setEditMode] = useState(false);
    const [title, setTitle] = useState(data.name || "Audience 1 Name");
    const { reportIsLoading } = useSelector((state) => state.reports);
    const {
        countryNotAvailable
    } = useSelector((state) => state.buildTargets);
    return (
        <div className="reportBuilder-leftside_targets-item-group">
            <div className="header">
                <div className="header-name" title={title}>
                    {!editMode && title}
                    <Input
                        type="text"
                        defaultValue={title}
                        style={{ display: editMode ? "inline" : "none" }}
                        onChange={(e) => setTitle(e.target.value)}
                        onBlur={() => {
                            setEditMode(false);
                        }}
                        onPressEnter={() => {
                            dispatch(updateBuildTargetItemName({
                                key: data.key,
                                name: title
                            }));
                            setEditMode(false);
                        }}
                    />
                </div>
                <div style={{
                    display: "flex",
                    gap: "1mm"
                }}
                >
                    <Button
                        style={{ display: editMode ? "none" : "inline" }}
                        className="header-btn"
                        type="link"
                        onClick={() => {
                            setEditMode(true);
                        }}
                        title="Edit"
                    >
                        <EditOutlined />
                    </Button>
                    <Button
                        style={{ display: editMode ? "none" : "inline" }}
                        className="header-btn"
                        type="link"
                        danger
                        onClick={() => {
                            dispatch(removeBuildTarget(data));
                        }}
                        disabled={reportIsLoading || countryNotAvailable}
                        title="Delete"
                    >
                        <DeleteOutlined />
                    </Button>
                </div>
            </div>
            <div className="body">
                {
                    data.groups.map((group, index) => (
                        <Group
                            key={group.code}
                            data={group}
                            parent={data}
                            groupId={index}
                            clickableAnd={!data.groups[index + 1]}
                        />
                    ))
                }
            </div>
        </div>
    );
};

export default TargetItemGroup;
